"use client"

import { ApertureStyles, T, FM, MAXW, SectionEyebrow, RevealGrid } from "./_shared"

export default function ApertureHowItWorks() {
  const steps = [
    {
      n: "01",
      t: "Drop your CSV",
      d: "Up to 1M rows. We auto-detect the email column and remember the mapping for next time.",
      pre: ["email,name,company", "founder@stripe.com,Patrick,Stripe", "info@acme.io,Mailbox,Acme", "test@mailinator.com,Demo,—"],
    },
    {
      n: "02",
      t: "Get a verdict in seconds",
      d: "The cleaner checks format, MX, duplicates, role/no-reply patterns, disposable domains, risky TLDs, and likely typos. Every flag gets a reason.",
      pre: ["→ syntax     ✓  pass", "→ mx         ✓  pass", "→ duplicate  ✓  first seen", "→ role       ✗  flagged: info@"],
    },
    {
      n: "03",
      t: "Export with the audit",
      d: "Download the cleaned CSV with verdict and reason columns attached. Mapper and Compare use the same resolved dataset, so you do not repeat spreadsheet work.",
      pre: ["✓ clean.csv ready", "✓ flagged rows include reasons", "✓ audit columns attached", "→ mapper / compare use same result"],
    },
  ]
  return (
    <section id="how-it-works" className="relative">
      <ApertureStyles />
      <div className={`${MAXW} mx-auto px-6 lg:px-10 py-12 sm:py-16 md:py-24`}>
        <SectionEyebrow>How it works</SectionEyebrow>
        <h2
          className="mt-3 leading-[1.0] tracking-[-0.035em] max-w-3xl"
          style={{ fontSize: "clamp(2rem, 4vw, 3.1rem)", fontWeight: 800 }}
        >
          Drop in. Clean out. <em style={{ color: T.acc, fontStyle: "italic", fontWeight: 700 }}>Three minutes flat.</em>
        </h2>

        <RevealGrid className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-reveal
              className="rounded-2xl p-6 flex flex-col apl-card-hover relative overflow-hidden"
              style={{
                background: T.surface,
                border: `1px solid ${T.hair}`,
                boxShadow: `0 1px 0 rgba(255,255,255,0.6) inset, 0 14px 36px -28px rgba(10,10,10,0.18)`,
                minHeight: 360,
                animationDelay: `${i * 100}ms`,
              }}
            >
              <div className="flex items-center justify-between">
                <span style={{ fontFamily: FM, fontSize: 11, letterSpacing: "0.14em", color: T.ink3 }}>
                  STEP / {s.n}
                </span>
                <span className="relative inline-flex" style={{ width: 8, height: 8 }}>
                  <span
                    aria-hidden
                    className="absolute inset-0 rounded-full"
                    style={{ background: T.acc, animation: "apl-ring-pulse 2s cubic-bezier(.2,.8,.2,1) infinite" }}
                  />
                  <span
                    className="relative rounded-full"
                    style={{ width: 8, height: 8, background: T.acc, boxShadow: `0 0 8px ${T.accGlow}` }}
                  />
                </span>
              </div>
              <h3 className="mt-5 tracking-[-0.02em]" style={{ fontSize: 19, fontWeight: 700 }}>
                {s.t}
              </h3>
              <p className="mt-2" style={{ fontSize: 13.5, color: T.ink2, lineHeight: 1.55 }}>{s.d}</p>
              <div
                className="mt-6 rounded-lg p-3.5 flex-1"
                style={{
                  background: T.bgSoft,
                  border: `1px solid ${T.hair}`,
                  fontFamily: FM, fontSize: 12, color: T.ink2, lineHeight: 1.7,
                }}
              >
                {s.pre.map((l) => (
                  <div
                    key={l}
                    style={{
                      whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                      color: l.includes("✗") ? T.bad : l.includes("✓") ? T.acc : T.ink3,
                    }}
                  >
                    {l}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </RevealGrid>
      </div>
    </section>
  )
}
